const autoSuggest = (router) => {
    console.log("router.query ** autoSuggest", router);
    return fetch(`${router.isSrp ? '' : 'activity/'}api/autoSuggest?text=${router.searchText}`).then((response) => response.json())
}
export default autoSuggest;